import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { environment } from 'src/environments/environment';
import 'iconify-icon';
import { GlobalService } from 'src/app/core/services/global.service';

const templateUrl = `./icon.component.html`;

@Component({
  selector: 'app-icon',
  templateUrl: templateUrl,
  styleUrls: [`./icon.component.scss`],
  standalone: false
})
export class IconComponent implements OnChanges, OnInit {

  @Input('icon') icon: string; //Nombre del icono
  @Input('opsz') opsz: number = 40;
  @Input('wght') wght: number = environment.options.iconFontWeight;
  idSet = this._gs.website.icon_id || 1;
  iconSafe: string;

  constructor(private _gs: GlobalService) {}

  ngOnInit(): void {
    this._gs.onUpdateIcon.subscribe((value: number) => {
      if (value) {
        this.idSet = value;
        this.changeValue();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.changeValue();
  }

  async changeValue() {
    if(!this.icon) console.error('Icono no encontrado');

    switch (this.idSet) {
      case 1: {
        const { materialSymbols } = await import('./setIcons/materialSymbols');
        let valueIcon1 = materialSymbols[this.icon] as string;
        if (!valueIcon1?.includes(':')) {
          valueIcon1 = 'material-symbols:' + valueIcon1;
        }
        this.iconSafe = valueIcon1;
        break;
      }

      case 2: {
        const { materialSymbolsLight } = await import(
          './setIcons/materialSymbolsLight'
        );
        let valueIcon2 = materialSymbolsLight[this.icon] as string;
        if (!valueIcon2?.includes(':')) {
          valueIcon2 = 'material-symbols-light:' + valueIcon2;
        }
        this.iconSafe = valueIcon2;
        break;
      }

      case 3: {
        const { solar } = await import('./setIcons/solar');

        let valueIcon3 = solar[this.icon] as string;
        if (!valueIcon3?.includes(':')) {
          valueIcon3 = 'solar:' + valueIcon3;
        }
        this.iconSafe = valueIcon3;
        break;
      }

      case 4: {
        const { huge } = await import('./setIcons/huge');

        let valueIcon4 = huge[this.icon] as string;
        if (!valueIcon4?.includes(':')) {
          valueIcon4 = 'hugeicons:' + valueIcon4;
        }
        this.iconSafe = valueIcon4;
        break;
      }

      case 5: {
        const { mingcute } = await import('./setIcons/mingcute');

        let valueIcon5 = mingcute[this.icon] as string;
        if (!valueIcon5?.includes(':')) {
          valueIcon5 = 'mingcute:' + valueIcon5;
        }
        this.iconSafe = valueIcon5;
        break;
      }
      case 6: {
        const { scout } = await import('./setIcons/scout');

        let valueIcon6 = scout[this.icon] as string;
        if (!valueIcon6?.includes(':')) {
          valueIcon6 = 'uil:' + valueIcon6;
        }
        this.iconSafe = valueIcon6;
        break;
      }
      case 7: {
        const { tdesign } = await import('./setIcons/tdesign');

        let valueIcon7 = tdesign[this.icon] as string;
        if (!valueIcon7?.includes(':')) {
          valueIcon7 = 'tdesign:' + valueIcon7;
        }
        this.iconSafe = valueIcon7;
        break;
      }
      case 8: {
        const { majesticons } = await import('./setIcons/majesticons');

        let valueIcon8 = majesticons[this.icon] as string;
        if (!valueIcon8?.includes(':')) {
          valueIcon8 = 'majesticons:' + valueIcon8;
        }
        this.iconSafe = valueIcon8;
        break;
      }
      case 9: {
        const { materialSymbolsBlack } = await import(
          './setIcons/materialSymbolsBlack'
        );

        let valueIcon9 = materialSymbolsBlack[this.icon] as string;
        if (!valueIcon9?.includes(':')) {
          valueIcon9 = 'material-symbols-light:' + valueIcon9;
        }
        this.iconSafe = valueIcon9;
        break;
      }
      case 10: {
        const { tdesignBlack } = await import('./setIcons/tdesignBlack');

        let valueIcon10 = tdesignBlack[this.icon] as string;
        if (!valueIcon10?.includes(':')) {
          valueIcon10 = 'tdesign:' + valueIcon10;
        }
        this.iconSafe = valueIcon10;
        break;
      }
      default:
        break;
    }
  }
}
